import React, { useEffect } from "react";
import "./AddressBook.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import Action_Btn from "../Common-Component/Common_Btn/Action_Btn/Action_Btn";
import {
  faArrowRight,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import CommonSelectAddress from "../Common-Component/CommonSelectAddress/CommonSelectAddress";
import AddAddressModal from "../Common-Component/Common_Modal/AddAddressModal/AddAddressModal";
import { useDispatch, useSelector } from "react-redux";
import { deleteAddress, getAllOrderAddress, getAllSippingOrderAddress } from "../../features/order/orderSlice";

const AddressBook = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "ADDRESS BOOK" },
  ];
 
  const shippingAddressdata = useSelector(
    (state) => state.order.allSppingOrdersAddress
  );
  const dispatch = useDispatch();

  useEffect(() => {
   
    dispatch(getAllSippingOrderAddress());
  }, [dispatch]);

  return (
    <>
      <section className="AddressBook">
        <div className="custom_container">
          <div className="breadcrump_holder">
            <div className="Breadcrumb_div">
              <Breadcrumb_comp data={breadcrumbData} />
            </div>
          </div>

          <div className="select_address_div">
            <p className="div_heading">Select Address</p>
            {shippingAddressdata?.data?.data?.length > 0 &&
                  shippingAddressdata.data.data?.map((val, index) => (
            <CommonSelectAddress Data={val} /> ))}

            <div className="add_new_address" onClick={() => setModalShow(true)}>
              <Action_Btn btn_name="Add New Address" icon={faPlus} />
            </div>
          </div>
        </div>
      </section>
      <AddAddressModal  type={"Shipping Information"} show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default AddressBook;
